import { Content, Button } from 'components/common';
import { intercom } from 'libs';

const ErrorPage = () => (
  <Content.Body>
    <div className="d-flex justify-content-center mt-44">
      <img alt="Error illustration" src="/images/error-page.png" style={{ maxWidth: 400 }} />
    </div>
    <div className="d-flex fw-bold h4 justify-content-center text-center">Hmmm, looks like something went wrong.</div>
    <p className="mx-auto text-center text-gray">
      You can try refreshing the page or&nbsp;
      <Button
        onClick={() => intercom.showMessage('I am having trouble with the website.')}
        text="bold"
        variant="link-inline"
      >
        contact support
      </Button>
      &nbsp;for help.
    </p>
  </Content.Body>
);

export default ErrorPage;
